module.exports = __webpack_public_path__ + "static/media/page-loading.7d8f6d5d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/page-loading.gif
// module id = 77
// module chunks = 0